import moment from 'moment';
import { BaseQuery2 } from '@/utils';

/**
 *
 * @scanSiteCode
 * @startDate
 * @endDate
 * @siteNames 下一站分拨集合
 */
export const OutletsNextSiteQuery = params => {
  let startDate = null;
  let endDate = null;
  if (moment().seconds() >= moment(moment().format('YYYY-MM-DD 09:00:00')).seconds()) {
    startDate = moment()
      .add(-7, 'days')
      .format('YYYY-MM-DD 09:00:00');
    endDate = moment().format('YYYY-MM-DD 08:59:59');
  } else {
    endDate = moment()
      .add(-1, 'days')
      .format('YYYY-MM-DD 08:59:59');
    startDate = moment()
      .add(-8, 'days')
      .format('YYYY-MM-DD 09:00:00');
  }
  return [
    {
      // 根据下一站集合查预计下一站省份
      simpleGranularity: 'all',
      dataSource: 'route_plan_result',
      dimensions: ['destinationSite', 'destinationSiteCode'],
      startDate: params.startDate,
      endDate: params.endDate,
      aggregators: BaseQuery2(),
      andFilters: [
        { key: 'scanType', value: '分拨发车' },
        { key: 'isDestinationCenter', value: '是' },
        { key: 'scanSiteCode', value: params.scanSiteCode },
      ],
      // inFilters: [
      //   {key: 'nextSite', value: params.siteNames},
      // ]
    },
    [
      {
        // 网点到达预计 0
        simpleGranularity: 'all',
        dataSource: 'route_plan_result',
        dimensions: ['destinationSite', 'destinationSiteCode'],
        startDate: params.startDate,
        endDate: params.endDate,
        aggregators: BaseQuery2(),
        andFilters: [
          { key: 'isOriginCenter', value: '是' },
          { key: 'isDestinationCenter', value: '是' },
          { key: 'scanType', value: '分拨到车' },
          { key: 'scanSiteCode', value: params.scanSiteCode },
          { key: 'destinationCenterCode', value: params.scanSiteCode },
        ],
        // inFilters: [
        //   {key: 'nextSite', value: params.siteNames},
        // ]
      },
      {
        // 网点到达实际 1
        simpleGranularity: 'all',
        dataSource: 'actual_load_unload_result',
        dimensions: ['destinationSite', 'destinationSiteCode'],
        startDate: params.startDate,
        endDate: params.endDate,
        aggregators: BaseQuery2(),
        andFilters: [
          { key: 'isOriginCenter', value: '是' },
          { key: 'isDestinationCenter', value: '是' },
          { key: 'scanType', value: '分拨卸车' },
          { key: 'scanSiteCode', value: params.scanSiteCode },
          { key: 'destinationCenterCode', value: params.scanSiteCode },
        ],
        // inFilters: [
        //   {key: 'nextSite', value: params.siteNames},
        // ]
      },
      {
        // 中转到达预计 2
        simpleGranularity: 'all',
        dataSource: 'route_plan_result',
        dimensions: ['destinationSite', 'destinationSiteCode'],
        startDate: params.startDate,
        endDate: params.endDate,
        aggregators: BaseQuery2(),
        andFilters: [
          { key: 'isOriginCenter', value: '否' },
          { key: 'isDestinationCenter', value: '是' },
          { key: 'scanType', value: '分拨到车' },
          { key: 'scanSiteCode', value: params.scanSiteCode },
          { key: 'destinationCenterCode', value: params.scanSiteCode },
        ],
        // inFilters: [
        //   {key: 'nextSite', value: params.siteNames},
        // ]
      },
      {
        // 中转到达实际 3
        simpleGranularity: 'all',
        dataSource: 'actual_load_unload_result',
        dimensions: ['destinationSite', 'destinationSiteCode'],
        startDate: params.startDate,
        endDate: params.endDate,
        aggregators: BaseQuery2(),
        andFilters: [
          { key: 'isOriginCenter', value: '否' },
          { key: 'isDestinationCenter', value: '是' },
          { key: 'scanType', value: '分拨卸车' },
          { key: 'scanSiteCode', value: params.scanSiteCode },
          { key: 'destinationCenterCode', value: params.scanSiteCode },
        ],
      },
      {
        // 4  库存卸车
        remak: '4 库存卸车',
        simpleGranularity: 'all',
        dataSource: 'actual_load_unload_result',
        dimensions: ['destinationSite', 'destinationSiteCode'],
        startDate: moment(params.startDate)
          .add(-3, 'days')
          .format('YYYY-MM-DD HH:mm:ss'),
        endDate: params.endDate,
        aggregators: BaseQuery2(),
        andFilters: [
          { key: 'scanType', value: '分拨卸车' },
          { key: 'isDestinationCenter', value: '是' },
          { key: 'scanSiteCode', value: params.scanSiteCode },
        ],
      },
      {
        // 5  库存装车
        remak: '5 库存装车',
        simpleGranularity: 'all',
        dataSource: 'actual_load_unload_result',
        dimensions: ['destinationSite', 'destinationSiteCode'],
        startDate: moment(params.startDate)
          .add(-3, 'days')
          .format('YYYY-MM-DD HH:mm:ss'),
        endDate: params.endDate,
        aggregators: BaseQuery2(),
        andFilters: [
          { key: 'scanType', value: '分拨装车' },
          { key: 'isDestinationCenter', value: '是' },
          { key: 'scanSiteCode', value: params.scanSiteCode },
        ],
        boundFilters: [
          {
            dimension: 'unloadAggregateTime',
            lowerValue: moment(params.startDate)
              .add(-3, 'days')
              .format('YYYY-MM-DD'),
            upperValue: moment(params.endDate).format('YYYY-MM-DD'),
            lowerEq: false,
            upperEq: false,
          },
        ],
        //
      },
      {
        // 6  优势产品卸车
        simpleGranularity: 'all',
        dataSource: 'actual_load_unload_result',
        dimensions: ['destinationSite', 'destinationSiteCode'],
        startDate: moment(params.startDate)
          .add(-3, 'days')
          .format('YYYY-MM-DD HH:mm:ss'),
        endDate: params.endDate,
        aggregators: BaseQuery2(),
        andFilters: [
          { key: 'superiorityProduct', value: '是' },
          { key: 'isDestinationCenter', value: '是' },
          { key: 'scanType', value: '分拨卸车' },
          { key: 'scanSiteCode', value: params.scanSiteCode },
        ],
      },
      {
        // 7  优势产品装车
        simpleGranularity: 'all',
        dataSource: 'actual_load_unload_result',
        dimensions: ['destinationSite', 'destinationSiteCode'],
        startDate: moment(params.startDate)
          .add(-3, 'days')
          .format('YYYY-MM-DD HH:mm:ss'),
        endDate: params.endDate,
        aggregators: BaseQuery2(),
        andFilters: [
          { key: 'superiorityProduct', value: '是' },
          { key: 'isDestinationCenter', value: '是' },
          { key: 'scanType', value: '分拨装车' },
          { key: 'scanSiteCode', value: params.scanSiteCode },
        ],
        boundFilters: [
          {
            dimension: 'unloadAggregateTime',
            lowerValue: moment(params.startDate)
              .add(-3, 'days')
              .format('YYYY-MM-DD'),
            upperValue: moment(params.endDate).format('YYYY-MM-DD'),
            lowerEq: false,
            upperEq: false,
          },
        ],
        //
      },
      {
        // 8 网点开单日均
        simpleGranularity: 'all',
        dataSource: 'actual_load_unload_result',
        dimensions: ['destinationCenterCode', 'destinationSiteCode'],
        endDate: endDate,
        startDate: startDate,
        aggregators: BaseQuery2(),
        queryType: "groupBy",
        andFilters: [
          { key: 'scanType', value: '录单' },
          { key: 'destinationCenterCode', value: params.scanSiteCode },
        ],
      },
    ],
  ];
};

